//
// Generated class EventItemPhase
//

/// <reference path="EventItemPhase_ManagedObject.ts" />

class EventItemPhase extends EventItemPhase_ManagedObject
{

}
